import dayjs from 'dayjs';
import { compareUsers, formatDatePreservingTimeValues, formatString, getAuthUser } from 'utils/helperMethods';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DimensionConfigType } from 'types/pricingSimulator';
dayjs.extend(relativeTime);

export const getAllProjectsDataParser = (
    data: any[] = [],
    config: any,
    dimensionConfigData: DimensionConfigType | null,
) => {
    try {
        const formattedData = data?.map((item: any) => {
            const { pricingSimulator = {}, commonConfig } = config;
            const dim1Attribute = dimensionConfigData?.dim1Attribute;
            const dim2Attribute = dimensionConfigData?.dim2Attribute;
            //   const { dim1Attribute, dim2Attribute } = pricingSimulator;
            const dim1Parsed = item?.project_filters?.dim1;
            const dim2Parsed = item?.project_filters?.dim2;
            const { start_timestamp, end_timestamp } = item?.simulation_time_period;
            const formattedSimulationStartDate = formatDatePreservingTimeValues(start_timestamp);
            const formattedSimulationEndDate = formatDatePreservingTimeValues(end_timestamp);
            const formattedPriceEffectiveEndDate = formatDatePreservingTimeValues(item?.price_effective_date);

            //only add the dimension object if its available in config.
            let dimensionObject = {};
            if (dim1Attribute) {
                dimensionObject = {
                    [dim1Attribute?.['key']]: formatString(dim1Parsed?.[dim1Attribute?.['key']]?.join(', ') || '', 15),
                };
            }
            if (dim2Attribute) {
                dimensionObject = {
                    ...dimensionObject,
                    [dim2Attribute?.['key']]: formatString(dim2Parsed?.[dim2Attribute?.['key']]?.join(', ') || '', 15),
                };
            }
            return {
                key: String(item?.project_id),
                projectName: item?.project_name,
                projectId: item?.project_id,
                createdBy: item?.created_by,
                avatarShortName: getAuthUser(item?.created_by),
                status: item?.status,
                lastUpdated: dayjs.unix(item?.updated_at).fromNow(),
                simulationPeriod: `${dayjs(formattedSimulationStartDate)
                    .add(6, 'day')
                    .format(commonConfig?.dateFormatAlt)} - ${dayjs(formattedSimulationEndDate)
                    .add(6, 'day')
                    .format(commonConfig?.dateFormatAlt)}`,
                priceEffectiveDate:
                    item?.price_effective_date &&
                    dayjs(formattedPriceEffectiveEndDate).add(6, 'day').format(commonConfig?.dateFormatAlt),
                ...dimensionObject,
                children: [{ isChild: true, isScenarioLoading: true }],
                responseRowData: item,
                isPrivate: item?.is_private,
                allowProjectEdit: compareUsers(item?.created_by),
            };
        });
        return formattedData;
    } catch (error) {
        throw error;
    }
};

//get all scenarios by project id parser
export const getAllScenarioParser = (data: any[], projectsData: any[]) => {
    try {
        const projectId = data?.[0]?.project_id;
        const result = projectsData?.map((project: any) => {
            if (project?.projectId === projectId) {
                const scenarios = data?.map((scenario) => {
                    return {
                        isChild: true,
                        key: `${scenario?.scenario_id}${scenario?.name}`,
                        projectName: scenario?.name,
                        projectId: projectId,
                        scenarioId: scenario?.scenario_id,
                        createdBy: scenario?.created_by,
                        avatarShortName: getAuthUser(scenario?.created_by),
                        isViewMode: !compareUsers(scenario?.created_by),
                        status: scenario?.status,
                        lastUpdated: dayjs.unix(scenario?.updated_at).fromNow(),
                        isPrivate: scenario.is_private ?? false,
                    };
                });
                return {
                    ...project,
                    children: scenarios,
                };
            }
            return {
                ...project,
            };
        });
        return result;
    } catch (error) {
        throw error;
    }
};
